var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, property, customElement } from "lit-element";
let LoaderRing = class LoaderRing extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 64;
        this.color = '#666666';
    }
    static get styles() {
        return css `
            :host {
                display: inline-block;
                position: relative;
                vertical-align: middle;
            }
            :host div {
                box-sizing: border-box;
                display: block;
                position: absolute;
                border: 6px solid #fff;
                border-radius: 50%;
                animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
            }
            :host div:nth-child(1) {
                animation-delay: -0.45s;
            }
            :host div:nth-child(2) {
                animation-delay: -0.3s;
            }
            :host div:nth-child(3) {
                animation-delay: -0.15s;
            }
            @keyframes lds-ring {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }`;
    }
    render() {
        let borderWidth = 6;
        if (this.size < 64) {
            borderWidth = 3;
        }
        const ringCss = `width: ${this.size}px; 
            height: ${this.size}px; 
            border-width: ${borderWidth}px; 
            border-color: ${this.color} transparent transparent transparent`;
        this.style.width = `${this.size}px`;
        this.style.height = `${this.size}px`;
        return html `<div style="${ringCss}"></div>
            <div style="${ringCss}"></div>
            <div style="${ringCss}"></div>
            <div style="${ringCss}"></div>`;
    }
};
__decorate([
    property({ type: Number })
], LoaderRing.prototype, "size", void 0);
__decorate([
    property({ type: String })
], LoaderRing.prototype, "color", void 0);
LoaderRing = __decorate([
    customElement('loader-ring')
], LoaderRing);
export default LoaderRing;
